import React, { useState } from 'react'
import { Translate } from 'react-localize-redux'
import { makeStyles } from '@material-ui/core/styles'
import {
  Card,
  FormControlLabel,
  Switch,
  Typography,
  Box,
  Divider,
} from '@material-ui/core'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { team as teamModule } from '../../redux/modules'

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    margin: 'auto',
    padding: theme.spacing(4),
  },
  titleWrapper: {
    marginBottom: theme.spacing(3),
  },
  title: {
    paddingBottom: theme.spacing(0.5),
  },
  detailsContainer: {
    flexDirection: 'column',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(2),
  },
  detailsContent: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(0.5),
    '& > p': {
      marginRight: theme.spacing(2),
    },
  },
}))

const privacySettingPropType = PropTypes.oneOfType([
  PropTypes.bool,
  PropTypes.number,
])

const PlayerProfilePrivacy = ({ team, patchTeam }) => {
  const classes = useStyles()

  const [privacy, setPrivacy] = useState({
    share_player_information: Boolean(team.share_player_information),
    share_player_statistics: Boolean(team.share_player_statistics),
    share_player_skills_with_team: Boolean(team.share_player_skills_with_team),
    share_player_skills_with_player: Boolean(
      team.share_player_skills_with_player
    ),
  })

  const handlePrivacySwitchChange = (event) => {
    setPrivacy({ ...privacy, [event.target.name]: event.target.checked })
    patchTeam(team.uuid, {
      [event.target.name]: event.target.checked === true ? 1 : 0,
    })
  }

  return (
    <>
      <Card>
        <Box className={classes.root}>
          <Box className={classes.titleWrapper}>
            <Typography variant="h3" component="h3" className={classes.title}>
              <Translate id="player.profile-privacy.title" />
            </Typography>
            <Typography variant="h6" component="h6">
              <Translate id="player.profile-privacy.subtitle" />
            </Typography>
          </Box>
          <Box className={classes.detailsContainer}>
            <Typography variant="h4" component="h4">
              <Translate id="player.profile-privacy.player-information.title" />
            </Typography>
            <Box className={classes.detailsContent}>
              <Typography variant="body2">
                <Translate id="player.profile-privacy.player-information.description" />
              </Typography>
              <FormControlLabel
                control={
                  <Switch
                    checked={privacy.share_player_information}
                    onChange={handlePrivacySwitchChange}
                    name="share_player_information"
                    color="primary"
                  />
                }
              />
            </Box>
            <Divider />
          </Box>
          {/*@fixme: temporary disabled https://pixelplus.atlassian.net/browse/CB-491*/}
          {/*<Box className={classes.detailsContainer}>*/}
          {/*  <Typography variant="h4" component="h4">*/}
          {/*    <Translate id="player.profile-privacy.player-statistics.title" />*/}
          {/*  </Typography>*/}
          {/*  <Box className={classes.detailsContent}>*/}
          {/*    <Typography variant="body2">*/}
          {/*      <Translate id="player.profile-privacy.player-statistics.description" />*/}
          {/*    </Typography>*/}
          {/*    <FormControlLabel*/}
          {/*      control={*/}
          {/*        <Switch*/}
          {/*          checked={privacy.share_player_statistics}*/}
          {/*          onChange={handlePrivacySwitchChange}*/}
          {/*          name="share_player_statistics"*/}
          {/*          color="primary"*/}
          {/*        />*/}
          {/*      }*/}
          {/*    />*/}
          {/*  </Box>*/}
          {/*  <Divider />*/}
          {/*</Box>*/}
          <Box className={classes.detailsContainer}>
            <Typography variant="h4" component="h4">
              <Translate id="player.profile-privacy.skills-with-team.title" />
            </Typography>
            <Box className={classes.detailsContent}>
              <Typography variant="body2">
                <Translate id="player.profile-privacy.skills-with-team.description" />
              </Typography>
              <FormControlLabel
                control={
                  <Switch
                    checked={privacy.share_player_skills_with_team}
                    onChange={handlePrivacySwitchChange}
                    name="share_player_skills_with_team"
                    color="primary"
                  />
                }
              />
            </Box>
            <Divider />
          </Box>
          <Box className={classes.detailsContainer}>
            <Typography variant="h4" component="h4">
              <Translate id="player.profile-privacy.skills-with-individual.title" />
            </Typography>
            <Box className={classes.detailsContent}>
              <Typography variant="body2">
                <Translate id="player.profile-privacy.skills-with-individual.description" />
              </Typography>
              <FormControlLabel
                control={
                  <Switch
                    checked={privacy.share_player_skills_with_player}
                    onChange={handlePrivacySwitchChange}
                    name="share_player_skills_with_player"
                    color="primary"
                  />
                }
              />
            </Box>
          </Box>
        </Box>
      </Card>
    </>
  )
}

PlayerProfilePrivacy.propTypes = {
  patchTeam: PropTypes.func.isRequired,
  team: PropTypes.shape({
    uuid: PropTypes.string.isRequired,
    share_player_information: privacySettingPropType.isRequired,
    share_player_statistics: privacySettingPropType.isRequired,
    share_player_skills_with_team: privacySettingPropType.isRequired,
    share_player_skills_with_player: privacySettingPropType.isRequired,
  }).isRequired,
}

export default connect(
  ({ team }) => ({
    team,
  }),
  {
    patchTeam: teamModule.patchTeam,
  }
)(PlayerProfilePrivacy)
